
import Assert from "tbAssert";

import ngSanitize from "angular-sanitize";
import ngAria from "angular-aria";
import uiBootstrap from "angular-ui-bootstrap";

import kendoDirectives from "tbClient/shims/kendoDirectives";
import AuthServiceModule from "tbClient/services/auth";

const mAuthSvc = new WeakMap();
const mStateParams = new WeakMap();
const mLogSvc = new WeakMap();

class TbLoginViewController {
    constructor(TbAuthService, $stateParams, $log) {
        Assert.StrictAssert(TbAuthService != null, "Assertion Failure: Missing Auth Service Dependency");
        Assert.StrictAssert($log != null, "Assertion Failure: Missing Log Service Dependency");
        mAuthSvc.set(this, TbAuthService);
        mStateParams.set(this, $stateParams);
        mLogSvc.set(this, $log);
    }

    $onInit() {
        const logSvc = mLogSvc.get(this);
        const params = mStateParams.get(this);

        // Debug: Log state parameters and authentication status
        logSvc.debug("=== TbLoginViewController Init ===");
        logSvc.debug("State parameters:", params);
        logSvc.debug("Reason:", params.reason);
        logSvc.debug("Message:", params.message);
        logSvc.debug("Is authenticated:", this.isAuthenticated);
        logSvc.debug("Show access denied alert:", this.showAccessDeniedAlert);
        logSvc.debug("Show sign out button:", this.showSignOutButton);
        logSvc.debug("=== End TbLoginViewController Init ===");
    }

    get isAuthenticated() {
        return mAuthSvc.get(this).isAuthenticated();
    }

    get accessDeniedMessage() {
        const params = mStateParams.get(this);

        if (params.reason === "expired") {
            return params.message || "Your session has expired. Please sign in again.";
        } else if (params.reason === "denied") {
            return params.message || "Access denied. Please sign in with proper credentials.";
        } else if (params.reason === "error") {
            return params.message || "An authentication error occurred. Please try signing in again.";
        }
        return null;
    }

    get showAccessDeniedAlert() {
        return this.accessDeniedMessage !== null;
    }

    get showSignOutButton() {
        const params = mStateParams.get(this);
        // Show sign out button for access denied scenarios (whether authenticated or not)
        // This handles cases where user is logged in via OneLogin but doesn't have app access
        return params.reason === "denied";
    }

    login() {
        mAuthSvc.get(this).login();
    }

    logout() {
        mLogSvc.get(this).debug("User signing out from login page...");
        mAuthSvc.get(this).logout();
    }
}

TbLoginViewController.$inject = [
    "TbAuthService",
    "$stateParams",
    "$log"
];

TbLoginViewController.dependencies = [
    ngSanitize,
    ngAria,
    AuthServiceModule,
    uiBootstrap,
    kendoDirectives
];

TbLoginViewController.template = require("./TbLoginView.tpl.html");
TbLoginViewController.controllerAs = "tbLoginView";

export default TbLoginViewController;



//////////////////
// WEBPACK FOOTER
// ./src/views/tb-login-view/TbLoginViewController.js
// module id = BW+j
// module chunks = 1